import { Shirt, Wine, Grape, Brain, Languages, HeartHandshake, Sparkles } from "lucide-react";

// Page-level copy (DE / EN / FR)
export const LP_UI = {
  de: {
    overline: "MYSYMP · Live Products",
    title: "KI-Produkte aus dem MYSYMP-Universum",
    sub: "Eine wachsende Familie KI-gestützter Anwendungen — entwickelt und begleitet von der MYSYMP AG. Vom persönlichen Stylisten bis zum digitalen Sommelier.",
    live: "Live",
    soon: "In Kürze",
    visit: "Zur Anwendung",
    features: "Highlights",
    homeTitle: "Live Products",
    homeSub: "Unsere KI-Anwendungen — im Einsatz und in Entwicklung.",
    homeCta: "Alle Produkte ansehen",
  },
  en: {
    overline: "MYSYMP · Live Products",
    title: "AI products from the MYSYMP universe",
    sub: "A growing family of AI-powered applications — built and stewarded by MYSYMP AG. From a personal stylist to a digital sommelier.",
    live: "Live",
    soon: "Coming soon",
    visit: "Open the app",
    features: "Highlights",
    homeTitle: "Live Products",
    homeSub: "Our AI applications — in use and in the making.",
    homeCta: "See all products",
  },
  fr: {
    overline: "MYSYMP · Live Products",
    title: "Produits IA de l'univers MYSYMP",
    sub: "Une famille grandissante d'applications pilotées par l'IA — conçues et accompagnées par MYSYMP AG. Du styliste personnel au sommelier numérique.",
    live: "Live",
    soon: "Bientôt",
    visit: "Ouvrir l'app",
    features: "Points forts",
    homeTitle: "Live Products",
    homeSub: "Nos applications IA — en service et en préparation.",
    homeCta: "Voir tous les produits",
  },
};

// status: "live" | "soon"
export const LP_PRODUCTS = [
  {
    slug: "popstyle",
    name: "POPSTYLE",
    Icon: Shirt,
    status: "live",
    url: "https://popstyle.ai",
    category: { de: "Fashion", en: "Fashion", fr: "Mode" },
    tagline: {
      de: "Dein Kleiderschrank, neu gedacht — der KI-Outfit-Planer & persönliche Stylist.",
      en: "Your wardrobe, reimagined — the AI outfit planner & personal stylist.",
      fr: "Ta garde-robe, repensée — le planificateur de tenues IA & styliste personnel.",
    },
    desc: {
      de: "Der intelligente Outfit-Planer, der deinen Stil versteht, den Anlass liest und perfekte Looks aus dem kuratiert, was du bereits besitzt.",
      en: "The intelligent outfit planner that understands your style, reads the occasion and curates perfect looks from what you already own.",
      fr: "Le planificateur de tenues intelligent qui comprend ton style, lit l'occasion et compose des looks parfaits à partir de ce que tu possèdes déjà.",
    },
    features: {
      de: [
        "30-Sekunden-Morgen: App öffnen, Anlass antippen, Outfit steht — kein ratloses Stehen vor dem Schrank.",
        "Hunderte Outfit-Kombinationen: Die KI kuratiert Looks aus deinem eigenen Kleiderschrank, inkl. Farb- & Muster-Harmonie.",
        "Kostenlos starten: Free-Tier dauerhaft gratis, keine Kreditkarte nötig. Verfügbar in 5 Sprachen.",
      ],
      en: [
        "30-second mornings: open the app, tap the occasion, your outfit is ready — no more standing puzzled at the closet.",
        "Hundreds of combinations: the AI curates looks from your own wardrobe, including colour & pattern harmony.",
        "Start for free: the free tier stays free, no credit card required. Available in 5 languages.",
      ],
      fr: [
        "Matins en 30 secondes : ouvre l'app, choisis l'occasion, la tenue est prête — fini l'hésitation devant l'armoire.",
        "Des centaines de combinaisons : l'IA compose des looks depuis ta propre garde-robe, harmonie des couleurs & motifs incluse.",
        "Commence gratuitement : le forfait gratuit reste gratuit, sans carte bancaire. Disponible en 5 langues.",
      ],
    },
  },
  {
    slug: "wine-pairing",
    name: "Wine Pairing",
    Icon: Wine,
    status: "live",
    url: "https://wine-pairing.online",
    category: { de: "Wein", en: "Wine", fr: "Vin" },
    tagline: {
      de: "Der KI-Sommelier, der in Sekunden die passende Weinbegleitung empfiehlt.",
      en: "The AI sommelier that recommends the perfect wine pairing in seconds.",
      fr: "Le sommelier IA qui recommande l'accord parfait en quelques secondes.",
    },
    desc: {
      de: "Beschreibe dein Gericht per Text oder Foto — Henri, der KI-Sommelier, empfiehlt die passende Weinbegleitung und erklärt, warum sie harmoniert. Inklusive digitalem Weinkeller mit Reife-Hinweisen und QR-Weinkarten für die Gastronomie.",
      en: "Describe your dish by text or photo — Henri, the AI sommelier, recommends the matching wine and explains why it works. Including a digital cellar with maturity alerts and QR wine lists for hospitality.",
      fr: "Décris ton plat par texte ou photo — Henri, le sommelier IA, recommande le vin idéal et explique pourquoi il s'accorde. Avec cave numérique et cartes des vins par QR pour la restauration.",
    },
  },
  {
    slug: "my-own-cuvee",
    name: "My Own Cuvée",
    Icon: Grape,
    status: "live",
    url: "https://myowncuvee.com",
    category: { de: "Wein", en: "Wine", fr: "Vin" },
    tagline: {
      de: "Eine persönliche, individuell komponierte Cuvée — als Konzept.",
      en: "A personal, individually composed cuvée — as a concept.",
      fr: "Une cuvée personnelle, composée sur mesure — en tant que concept.",
    },
    desc: {
      de: "Die Idee einer ganz persönlichen Cuvée, individuell zusammengestellt. My Own Cuvée ist ein Konzept aus dem MYSYMP-Universum — keine feste Weinlinie und kein Weinverkauf.",
      en: "The idea of a truly personal cuvée, composed individually. My Own Cuvée is a concept from the MYSYMP universe — not a fixed wine line and no wine sales.",
      fr: "L'idée d'une cuvée vraiment personnelle, composée sur mesure. My Own Cuvée est un concept de l'univers MYSYMP — pas une ligne de vins fixe, aucune vente de vin.",
    },
  },
  { slug: "neurobond", name: "NEUROBOND", Icon: Brain, status: "soon", category: { de: "MYSYMP Lab", en: "MYSYMP Lab", fr: "MYSYMP Lab" } },
  { slug: "interlingua", name: "INTERLINGUA", Icon: Languages, status: "soon", category: { de: "MYSYMP Lab", en: "MYSYMP Lab", fr: "MYSYMP Lab" } },
  { slug: "bestbuddy", name: "BESTBUDDY", Icon: HeartHandshake, status: "soon", category: { de: "MYSYMP Lab", en: "MYSYMP Lab", fr: "MYSYMP Lab" } },
  { slug: "belosophie", name: "belosophie", Icon: Sparkles, status: "soon", category: { de: "MYSYMP Lab", en: "MYSYMP Lab", fr: "MYSYMP Lab" } },
];

export const LP_SOON_LINE = {
  de: "Ein neues KI-Produkt aus dem MYSYMP-Universum. Details folgen in Kürze.",
  en: "A new AI product from the MYSYMP universe. Details coming soon.",
  fr: "Un nouveau produit IA de l'univers MYSYMP. Détails à venir.",
};
